import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ALLOWED_SIZES, ProjectScope, ProjectType, SpaceType } from "containers/NewProject/NewProject";

import { useAuth } from "contexts/AuthContext";
import { Location, NewProjectModalFloorInput } from "store/atoms/NewProject/newProjectAtoms";

type CreateProjectMetadata = {
  location: Location;
  spaceType: SpaceType;
  projectType: ProjectType;
  projectScopes: ProjectScope[];
  size: keyof typeof ALLOWED_SIZES;
  unitSystem: "imperial" | "metric";
  projectStartDate?: string;
  // floorplans: {
  //   id: string;
  //   filename: string;
  //   fileType: string;
  // }[];
}

type UseCreateProjectMutationVariables = {
  workspaceId: string;
  name: string;
  description: string;
  metadata?: CreateProjectMetadata;
  floors?: NewProjectModalFloorInput[];
  makePublic?: boolean;
};

export const useCreateProjectMutation = () => {
  const queryClient = useQueryClient();
  const { authApi } = useAuth();
  return useMutation({
    mutationFn: async (payload: UseCreateProjectMutationVariables) => {
      const { data } = await authApi.post<Project>(`/project`, payload);
      return data;
    },
    onSuccess: (_, { workspaceId }) => {
      queryClient.invalidateQueries({
        queryKey: ["projects", workspaceId],
      });
    },
  });
};
